var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVkMusic = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/icons/vk_music.svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.125 2.125C1.034 3.215 1 4.952 1 8.36c3.054 0 4.96-1.311 6.633-2.461 1.307-.899 2.47-1.7 3.927-1.7 2.167 0 4.06 1.533 5.063 2.346.142.114.265.215.37.294-.032-2.43-.202-3.799-1.118-4.714C14.751 1 12.94 1 9.32 1h-.64C5.06 1 3.25 1 2.125 2.125z",
  fill: "#07F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 8.36c3.054 0 4.96-1.311 6.634-2.462C8.94 5 10.104 4.2 11.56 4.2c2.167 0 4.06 1.532 5.063 2.345.142.114.265.214.37.294C17 7.395 17 8.006 17 8.68v.64c0 3.621 0 5.431-1.125 6.556C14.8 16.95 13.1 16.998 9.79 17H8.21c-3.31-.002-5.01-.05-6.085-1.125C1 14.75 1 12.94 1 9.32v-.96z",
  fill: "#F45FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.4 9.156a.72.72 0 0 1 1.44 0v2.888a.72.72 0 0 1-1.44 0V9.156zM10.84 7.316a.72.72 0 0 1 1.44 0v6.568a.72.72 0 0 1-1.44 0V7.316zM8.28 9.156a.72.72 0 0 1 1.44 0v2.888a.72.72 0 0 1-1.44 0V9.156zM5.72 10.196a.72.72 0 0 1 1.44 0v.808a.72.72 0 0 1-1.44 0v-.808zM3.16 10.196a.72.72 0 0 1 1.44 0v.808a.72.72 0 0 1-1.44 0v-.808z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/icons/vk_music.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(1 1)",
  d: "M0 0h16v16H0z"
})))));
export { SvgVkMusic as ReactComponent };